import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { UpdateNotice } from "./UpdateNotice";
import "./styles.css";
import "./update-notice.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <UpdateNotice><App /></UpdateNotice>
  </StrictMode>,
);
